
const digest = 'f5802dc026b2c775775846fff08f8f1b4b07b8e1274e5562876b0ebc0d48c488';
const classes = {"wrapper":"_wrapper_1y84s_1","image":"_image_1y84s_7","date":"_date_1y84s_12","title":"_title_1y84s_17","label":"_label_1y84s_22"};
const css = `._wrapper_1y84s_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
}
._wrapper_1y84s_1 ._image_1y84s_7 {
  border: 1px solid #f0f7fe;
  padding: 20px;
  border-radius: 100%;
}
._wrapper_1y84s_1 ._date_1y84s_12 {
  font-size: 16px;
  font-weight: 500;
  color: #3c3f9c;
}
._wrapper_1y84s_1 ._title_1y84s_17 {
  font-size: 20px;
  font-weight: 600;
  color: #3c3f9c;
}
._wrapper_1y84s_1 ._label_1y84s_22 {
  font-size: 16px;
}
._wrapper_1y84s_1 ._label_1y84s_22 span {
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  